import TeamSection from '../TeamSection';

export const homeObjOne = {
  id: "work",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Our Work",
  headLine: "Placeholder Headline",
  description: "Placeholder Description",
  buttonLabel: "Button placeholder",
  imgStart: true,
  img: require("../../images/svg-1.svg").default,
  alt: "Marketing strategy illustration showing growth and success",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjTwo = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "About Us",
  headLine: "Meet Our Talented Team",
  description: "Meet our talented team at Minute Growth",
  buttonLabel: "",
  imgStart: false,
  dark: true,
  primary: true,
  darkText: false,
  hideImage: true,
  showMediaGallery: true,
  additionalComponent: TeamSection
};

export const homeObjThree = {
  id: "team",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Premium Marketing",
  headLine: "We get it done",
  description: "Get placements worldwide",
  buttonLabel: "Get Started",
  imgStart: true,
  img: require("../../images/svg-3.svg").default,
  alt: "Global marketing reach illustration showing worldwide connectivity",
  dark: true,
  primary: true,
  darkText: false,
};
